// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"444":"6c24a38d","587":"060532a4","594":"65b5b0d1","676":"a92b9900","799":"e9142c73","823":"8fc3124f","937":"374e61c0"}[chunkId] + ".css";
};